import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import "react-toastify/dist/ReactToastify.css";
import CartTitle from "../CartTitle";
import DesignCard from "../DesignCard";
import CustomButton from "../CustomButton";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  fetchToursDetail,
  ApproveRejectTour,
  TourGalleryModeration,
} from "../../redux/moderation/tours/actions";
import CrossIcon from "../../assets/images/close_icon.svg";
import TickIcon from "../../assets/images/tick_icon.svg";
import history from "../../history";
import InputText from "../InputText";
import config from "../../utils/config";
import { fetchPartnersDetails } from "../../redux/partners/actions";
import moment from "moment";
import get from "lodash/get";

export default function ExperiencePreviewPage(props) {
  
  const _ = { get };
  const { elements } = useSelector((state) => state.Elements);
  const {  userProfile } = useSelector((state) => state.Auth);

  return (
    <React.Fragment>
      <div className="hideSearch mt-4">
        <Form>
          <Row>
            <Col sm={12}>
              <CartTitle
                title={`${props &&
                  props.tourDetailsData &&
                  props.tourDetailsData.name} by ${userProfile.fName} ${userProfile.lName}`}
                iconClass={"hideexcel"}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
              />
            </Col>
          </Row>
          <Card className="mb-3">
            <CardBody>
              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                    <span > {_.get(
                        elements,
                        "euToursElement.experiencePersonalPreviewInfo.partnerDeatilHeadingElement",
                        "Partner Detail"
                      )}</span>
                  </h2>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                   name={_.get(
                    elements,
                    "euToursElement.experiencePersonalPreviewInfo.nameLabel",
                    "Name"
                  )}
                    titleName={`${userProfile.fName} ${userProfile.lName}`}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                      name={_.get(
                        elements,
                        "euToursElement.experiencePersonalPreviewInfo.emailLabel",
                        "Email"
                      )}
                      titleName={`${userProfile.contact.email}`}
                  />
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                    <span> {_.get(
                        elements,
                        "euToursElement.experiencePersonalPreviewInfo.tourDetailHeadingElement",
                        "Experience Detail"
                      )}</span>
                  </h2>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalPreviewInfo.nameLabel",
                      "Name"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.name
                        ? props.tourDetailsData.name
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                     name={_.get(
                      elements,
                      "euToursElement.experiencePersonalPreviewInfo.startLocationLabel",
                      "Start Location"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.startPoint
                        ? props.tourDetailsData.startPoint
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalPreviewInfo.startLocationLatitudeLabel",
                      "Start Location Latitude"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.startPointSourceLatitude
                        ? props.tourDetailsData.startPointSourceLatitude
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalPreviewInfo.startLocationLongitudeLabel",
                      "Start Location Longitude"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.startPointSourceLongitude
                        ? props.tourDetailsData.startPointSourceLongitude
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalPreviewInfo.endLocationLabel",
                      "End Location"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.endPoint
                        ? props.tourDetailsData.endPoint
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalPreviewInfo.endLocationLatitude",
                      "End Location Latitude"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.endPointSourceLatitude
                        ? props.tourDetailsData.endPointSourceLatitude
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                     name={_.get(
                      elements,
                      "euToursElement.experiencePersonalPreviewInfo.endLocationLongitude",
                      "End Location Longitude"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.endPointSourceLongitude
                        ? props.tourDetailsData.endPointSourceLongitude
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalPreviewInfo.startDateLabel",
                      "Start Date"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.startDate
                        ? moment(props.tourDetailsData.startDate).format(
                            "DD/MM/YYYY"
                          )
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                     name={_.get(
                      elements,
                      "euToursElement.experiencePersonalPreviewInfo.endDateLabel",
                      "End Date"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.endDate
                        ? moment(props.tourDetailsData.endDate).format(
                            "DD/MM/YYYY"
                          )
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalPreviewInfo.regionLabel",
                      "Region"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.region
                        ? props.tourDetailsData.region
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalPreviewInfo.countryLabel",
                      "Country"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.country
                        ? props.tourDetailsData.country
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalPreviewInfo.distanceCoveredLabel",
                      "Estimated Distance Covered (KM)"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.distanceCovered
                        ? props.tourDetailsData.distanceCovered
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={12} className="mb-4 mt-3">
                  <DesignCard
                      name={_.get(
                        elements,
                        "euToursElement.experiencePersonalPreviewInfo.descriptionLabel",
                        "Description"
                      )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.description
                        ? props.tourDetailsData.description
                        : "N/A"
                    }
                  />
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                    <span> {_.get(
                        elements,
                        "euToursElement.experiencePersonalPreviewInfo.mediaTitle",
                        "Media"
                      )}</span>
                  </h2>
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <div className="image_heading">
                  {_.get(
                      elements,
                      "euToursElement.experiencePersonalPreviewInfo.thumbnailImageLabel",
                      "Experience Landing Page - Thumbnail - Common (160 x 190 px)"
                    )}
                  </div>
                  {props &&
                  props.tourDetailsData &&
                  props.tourDetailsData.thumbnailImage ? (
                    <img
                      className="image_bikeman"
                      src={`${config.imageBaseUrl}/${props &&
                        props.tourDetailsData &&
                        props.tourDetailsData.thumbnailImage}
                      `}
                      alt="img"
                    />
                  ) : (
                    "N/A"
                  )}
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <div className="image_heading">
                  {_.get(
                      elements,
                      "euToursElement.experiencePersonalPreviewInfo.thumbnailImageDetailPageLabel",
                      "Partner Detail Page - Experience Listing Thumbnail - Common (360 x 310 px)"
                    )}
                  </div>
                  {props &&
                  props.tourDetailsData &&
                  props.tourDetailsData.thumbnailPartnerImage ? (
                    <img
                      className="image_bikeman"
                      src={`${config.imageBaseUrl}/${props &&
                        props.tourDetailsData &&
                        props.tourDetailsData.thumbnailPartnerImage}
                      `}
                      alt="img"
                    />
                  ) : (
                    "N/A"
                  )}
                </Col>
              </Row>
              <Row>
                <Col md={12} className="mt-4 mb-2">
                  <div className="image_heading">
                  {_.get(
                      elements,
                      "euToursElement.experiencePersonalPreviewInfo.galleryImageLabel",
                      "Gallery Images Common"
                    )}
                  </div>
                </Col>
                {props &&
                props.tourDetailsData &&
                props.tourDetailsData.images && props.tourDetailsData.images.length > 0
                  ? props.tourDetailsData.images.map((item) => (
                      <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                        <img
                          className="image_bikeman"
                          src={`${config.imageBaseUrl}/${item}`}
                          alt="img"
                        />
                      </Col>
                    ))
                  : "N/A"}
              </Row>

              <div className="d-flex justify-content-center justify-content-lg-end position-relative mt-5">
                <CustomButton
                  customType={"button"}
                  name={_.get(
                    elements,
                    "euToursElement.experiencePersonalPreviewInfo.backLabel",
                    "Back"
                  )}
                  customClass={"btn-outline-dark bg-none btnthemeColor"}
                  customClick={() => props.handleToggleModel()}
                />
              </div>
            </CardBody>
          </Card>
        </Form>
      </div>
    </React.Fragment>
  );
}


